// Generated by Melange

import * as Belt__Belt_Array from "melange.belt/belt_Array.js";
import * as Buhta_cabinet__Box from "../../components/html/Box.js";
import * as Buhta_cabinet__Button from "../../components/html/Button.js";
import * as Buhta_cabinet__Field from "../../components/html/Field.js";
import * as Buhta_cabinet__FormView from "../../components/html/FormView.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_components__ToastContainer from "../../../../../packages/components/src/moleculas/ToastContainer.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function RecoverPasswordForm(Props) {
  let payload = Props.payload;
  const match = React.useState(function () {
    
  });
  const setToast = match[1];
  const match$1 = React.useState(function () {
    return true;
  });
  const setPasswordHidden = match$1[1];
  const passwordHidden = match$1[0];
  const match$2 = React.useState(function () {
    return "";
  });
  const setPassword = match$2[1];
  const initialFocusRef = React.useRef(null);
  let tmp;
  let exit = 0;
  if (payload !== undefined && !(typeof payload === "string" || payload.NAME !== "AuthFlow")) {
    const payload$1 = payload.VAL;
    const __x = payload$1.messages;
    const __x$1 = payload$1.errors;
    tmp = JsxRuntime.jsxs(Buhta_cabinet__FormView.make, {
      onSubmit: (function (param) {
        
      }),
      initialFocusRef: initialFocusRef,
      action: "",
      method_: "POST",
      className: "mt-8",
      children: [
        Belt__Belt_Array.mapWithIndex(__x, (function (index, msg) {
          const Key = "error-" + String(index);
          return JsxRuntime.jsx("span", {
            children: msg.text,
            className: "mt-2 text-asphalt"
          }, Key);
        })),
        JsxRuntime.jsx("input", {
          name: "csrf_token",
          type: "hidden",
          value: payload$1.csrf_token
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Buhta_cabinet__Field.make, {
              label: "Пароль",
              type_: passwordHidden ? "password" : "text",
              name: "password",
              required: true,
              onChange: (function (value) {
                Curry._1(setPassword, (function (param) {
                  return value;
                }));
              }),
              autoComplete: "off",
              className: "mt-4",
              value: match$2[0]
            }),
            JsxRuntime.jsx("button", {
              children: passwordHidden ? JsxRuntime.jsx("img", {
                  src: StaticAsset.src("/static/icons/eye-closed.svg")
                }) : JsxRuntime.jsx("img", {
                  src: StaticAsset.src("/static/icons/eye-opened.svg")
                }),
              className: "absolute right-4 top-5",
              tabIndex: -1,
              type: "button",
              onClick: (function (param) {
                Curry._1(setPasswordHidden, (function (param) {
                  return !passwordHidden;
                }));
              })
            })
          ],
          className: "relative"
        }),
        Belt__Belt_Array.mapWithIndex(__x$1, (function (index, error) {
          const Key = "error-" + String(index);
          return JsxRuntime.jsx("span", {
            children: error.text,
            className: "mt-2 text-sm text-red-600"
          }, Key);
        })),
        JsxRuntime.jsx(Buhta_cabinet__Button.make, {
          kind: "primary",
          name: "method",
          value: "password",
          type_: "submit",
          className: "mt-6",
          isWide: true,
          children: "Восстановить"
        })
      ]
    });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
      children: "Server didn't respond with the payloads"
    });
  }
  return JsxRuntime.jsx(Buhta_components__ToastContainer.make, {
    toast: match[0],
    onExpired: (function (param) {
      Curry._1(setToast, (function (param) {
        
      }));
    }),
    children: JsxRuntime.jsxs(Buhta_cabinet__Box.make, {
      title: "Восстановить пароль",
      className: "relative",
      children: [
        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
          className: "text-gray-medium",
          children: "Введите новый пароль"
        }),
        tmp
      ]
    })
  });
}

const make = RecoverPasswordForm;

export {
  make,
}
/* Buhta_cabinet__Box Not a pure module */
